export default __webpack_public_path__ + "static/media/virtual.c7cc01c4.svg";